import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHotelMapPreloader = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #ededed;
  border-radius: ${(props) => props.theme.shape.borderRadiusBig};
`;

const HotelMapPreloader = ({ children, ...props }) => (
  <StyledHotelMapPreloader {...props}>{children}</StyledHotelMapPreloader>
);

HotelMapPreloader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HotelMapPreloader;
